/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { FxIdDomainSettingsDimensions } from './FxIdDomainSettingsDimensions';
import {
    instanceOfFxIdDomainSettingsDimensions,
    FxIdDomainSettingsDimensionsFromJSON,
    FxIdDomainSettingsDimensionsFromJSONTyped,
    FxIdDomainSettingsDimensionsToJSON,
} from './FxIdDomainSettingsDimensions';

/**
 * @type FxIdDomainSettingsPresentationOptionsMaxRatio
 * Максиальное соотношение сторон
 * @export
 */
export type FxIdDomainSettingsPresentationOptionsMaxRatio = FxIdDomainSettingsDimensions;

export function FxIdDomainSettingsPresentationOptionsMaxRatioFromJSON(json: any): FxIdDomainSettingsPresentationOptionsMaxRatio {
    return FxIdDomainSettingsPresentationOptionsMaxRatioFromJSONTyped(json, false);
}

export function FxIdDomainSettingsPresentationOptionsMaxRatioFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdDomainSettingsPresentationOptionsMaxRatio {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdDomainSettingsDimensions(json)) {
        return FxIdDomainSettingsDimensionsFromJSONTyped(json, true);
    }

    return {} as any;
}

export function FxIdDomainSettingsPresentationOptionsMaxRatioToJSON(json: any): any {
    return FxIdDomainSettingsPresentationOptionsMaxRatioToJSONTyped(json, false);
}

export function FxIdDomainSettingsPresentationOptionsMaxRatioToJSONTyped(value?: FxIdDomainSettingsPresentationOptionsMaxRatio | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    if (instanceOfFxIdDomainSettingsDimensions(value)) {
        return FxIdDomainSettingsDimensionsToJSON(value as FxIdDomainSettingsDimensions);
    }

    return {};
}

